<template>
  <div id="partner" class="body">
    <Top />

    <div role="main" class="main">
      <section class="page-header page-header-classic page-header-sm">
        <div class="container">
          <div class="row">
            <div class="col-md-8 order-2 order-md-1 align-self-center p-static">
              <h1 data-title-border>パートナー様へ</h1>
            </div>
            <div class="col-md-4 order-1 order-md-2 align-self-center">
              <ul class="breadcrumb d-block text-md-right">
                <li><router-link to="/index">Home</router-link></li>
                <li class="active">パートナー様へ</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section class="container py-3">
        <div class="policy p-3 mb-3">
          <h2>ご挨拶</h2>
          <p>
            InnoSourceは、お客様のニーズを最優先に、よりよいサービスの提供を目指し、
            常に既存モデルの限界を打ち破っていくことをポリシーとしています。
            お客さまに対して新たなかつ独自の価値を提供すべく継続的な努力をしたいと考えております。
            失敗を恐れず、果敢にチャレンジし、継続的な終わりなき成長を遂げていきながら
            取引先のビジネスパートナー様と、互いの理解、尊重、強い協力関係を築き、共栄を実現したいと思っております。
            今後ともご愛顧を賜りますよう、お願い申し上げます。
          </p>
        </div>

        <div class="dual-panel">
          <article class="panel">
            <div class="panel-body">
              <h3>お問い合わせに関する同意</h3>
              <p>以下の「個人情報の取り扱い」をご確認頂いたうえお問い合わせください。</p>
              <div class="consent">
                <pre>
【お問合せ窓口】
イノソース株式会社 個人情報問合せ窓口
〒850-0035 長崎県長崎市元船町9-18 2階
メールアドレス：info@innosource.co.jp
※ 土・日曜日、祝日、年末年始、ゴールデンウィーク期間、
夏季休暇期間は翌営業日以降の対応とさせていただきます。
                </pre>
              </div>
            </div>
          </article>

          <article class="panel">
            <div class="panel-body">
              <h3>個人情報取り扱い</h3>
              <p>
                お問合せにおけるお客様の個人情報につきましては、イノソース株式会社にて、下記の通り、お取り扱いいたします。
              </p>
              <p>
                ＜情報の利用目的＞●お問合せへの対応
                ＜情報の保管＞●お客様の個人情報は、適切に管理し、当社が必要と判断する期間保管させていただきます。
                ＜情報の提供・開示＞次の場合を除き、お客様の同意なく個人情報を第三者に提供または開示することはありません。
              </p>
            </div>
          </article>
        </div>

        <div class="policy p-3 mt-3">
          <h3>事務所</h3>
          <ul>
            <li>住所: 〒850-0035 長崎県長崎市元船町9-18 2階</li>
            <li>電車: 長崎電軌本線 五島町駅 徒歩3分 / 大波止駅 徒歩4分 / 西九州新幹線 長崎駅 徒歩10分</li>
            <li>Email: info@innosource.co.jp</li>
            <li>受付時間: 平日10:00～12:00 13:00～17:30（土日、祝祭日、年末年始、弊社が定める定休日を除く）</li>
          </ul>
        </div>
      </section>
    </div>

    <Foot />
  </div>
</template>

<script>
import Top from '@/components/top';
import Foot from '@/components/foot';

export default {
  name: 'partner',
  components: {
    Top,
    Foot,
  },
};
</script>
